import React from 'react';
import { LayoutMode } from '../types';
import classNames from 'classnames';
import { NeueCanvasButton } from '../components/neue-button/canvas';
import { NeueButtonBase } from '../components/neue-button/base';

export const TalkToJourneyPotentialQuestions = ({
  potentialQuestions,
  onChooseQuestion,
  layoutMode,
}: {
  potentialQuestions: string[];
  onChooseQuestion: (question: string) => void;
  layoutMode: LayoutMode;
}) => {
  const potentialQuestionsForLayout = layoutMode === 'web' ? potentialQuestions : potentialQuestions.slice(0, 2);

  return (
    <div className={classNames('neue-text-editor flex flex-col space-y-[1px] w-full transition-opacity rounded-lg', {
      'opacity-0': potentialQuestionsForLayout.length === 0,
      'opacity-100': potentialQuestionsForLayout.length > 0,
    })}>
      {potentialQuestionsForLayout.map((question, index) => (      
        <NeueButtonBase
          className={classNames('p-2 text-neue-journey-fg-90 !justify-start !items-start text-left', '!rounded-none', {
            '!rounded-b-lg': index === potentialQuestionsForLayout.length - 1,
            '!rounded-tr-lg': index === 0,
          })}
          backgroundClassName={classNames('!rounded-none', {
            '!rounded-b-lg': index === potentialQuestionsForLayout.length - 1,
            '!rounded-tr-lg': index === 0,
          })}
          baseColor={'rgb(var(--neue-journey-fg-20))'}
          gradientMaxOpacity={0.2}
          onClick={() => onChooseQuestion(question)}>
            {question}
        </NeueButtonBase>
      ))}
    </div>
  )
}
